// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

const THEME_LIGHT = {
    "--color-background": "white",
    "--color-background-inverted": "black",
    "--color-menu": "white",
    "--color-menu-raised": "rgb(245,245,245)",
    "--color-text": "rgb(71, 74, 77)",
    // "--color-text": "black",
    "--color-text-light": "rgb(160,160,160)",
    "--color-accent-45": "rgb(240,160,133,0.45)",
    "--color-panel": "rgb(246, 246, 246)",
    "--color-background-raised": "transparent",
    "--color-background-gray": "rgb(252,252,252)",
    "--color-background-modal": "rgba(255,255,255,0.8)",
    "--color-background-modal-noblur": "rgba(255,255,255,0.96)",
    "--color-background-document": "rgba(240,240,240,0.4)",
    "--color-background-document-noblur": "rgba(250,250,250,0.9)",
    "--color-background-input": "rgb(245,245,245)",
    "--color-background-input-transparent": "transparent",
    "--color-background-disabled": "rgb(245,245,245)",
    "--color-text-input-placeholder": "#3C3C434D",
    "--color-signature-pad": "rgb(248,248,248)",
    "--color-signature-line": "rgb(220,220,220)",
    "--color-border": "rgb(230,230,230)",
    "--color-border-light": "rgb(245,245,245)",
    "--color-border-select": "var(--color-primary)",
    "--color-hover": "rgb(250,250,250)",
    "--color-hover-04": "rgb(250,250,250,0.04)",
    "--color-checkbox": "rgb(240,240,240)",
    "--form-icon": "url(https://static.stax.ai/images/icons/form.png)",
    "--script-icon": "url(https://static.stax.ai/images/icons/script.png)",
    "--create-icon": "url(https://static.stax.ai/images/icons/create.png)",
    "--folder-icon": "url(https://static.stax.ai/images/icons/folder.png)",
    "--folder-disabled-icon": "url('https://static.stax.ai/images/icons/folder-disabled.png')",
    "--folder-big-icon": "url('https://static.stax.ai/images/icons/folder-big.png')",
    "--close-icon": "url(https://static.stax.ai/images/icons/close.png)",
    "--settings-icon": "url(https://static.stax.ai/images/nav/settings.png)",
    "--gear-icon": "url('https://static.stax.ai/images/icons/gear.png')",
    "--color-bright-shadow": "white",
    "--color-scrollbar": "rgb(190,190,190)",
    "--filter-invert": "unset",
    "--filter-brightness": "unset",
    "--filter-brightness-more": "unset",
};

const THEME_DARK = {
    "--color-background": "rgb(12,12,12)",
    "--color-background-inverted": "rgb(248,248,248)",
    "--color-menu": "rgb(30,30,30)",
    "--color-menu-raised": "rgb(24,24,24)",
    "--color-text": "rgb(200,200,200)",
    "--color-text-light": "rgb(100,100,100)",
    "--color-accent-45": "rgb(145,94,78,0.45)",
    "--color-panel": "rgb(30,30,30)",
    "--color-background-raised": "rgb(24,24,24)",
    "--color-background-gray": "rgb(30,30,30)",
    "--color-background-modal": "rgba(0,0,0,0.7)",
    "--color-background-modal-noblur": "rgba(0,0,0,0.96)",
    "--color-background-document": "rgba(0,0,0,0.4)",
    "--color-background-document-noblur": "rgba(10,10,10,0.9)",
    "--color-background-input": "rgb(30,30,30)",
    "--color-background-input-transparent": "rgb(30,30,30)",
    "--color-background-disabled": "rgb(24,24,24)",
    "--color-text-input-placeholder": "#EBEBF54D",
    "--color-signature-pad": "rgb(30,30,30)",
    "--color-signature-line": "rgb(80,80,80)",
    "--color-border": "rgb(50,50,50)",
    "--color-border-light": "rgb(25,25,25)",
    "--color-border-select": "var(--color-border)",
    "--color-hover": "rgb(40,40,40)",
    "--color-hover-04": "rgb(250,250,250,0.04)",
    "--color-checkbox": "rgb(50,50,50)",
    "--form-icon": "url(https://static.stax.ai/images/icons/dark/form.png)",
    "--script-icon": "url(https://static.stax.ai/images/icons/dark/script.png)",
    "--create-icon": "url(https://static.stax.ai/images/icons/dark/create.png)",
    "--folder-icon": "url(https://static.stax.ai/images/icons/dark/folder.png)",
    "--folder-disabled-icon": "url('https://static.stax.ai/images/icons/dark/folder-disabled.png')",
    "--folder-big-icon": "url('https://static.stax.ai/images/icons/dark/folder-big.png')",
    "--close-icon": "url(https://static.stax.ai/images/icons/dark/close.png)",
    "--settings-icon": "url(https://static.stax.ai/images/nav/dark/settings.png)",
    "--gear-icon": "url('https://static.stax.ai/images/icons/dark/gear.png')",
    "--color-bright-shadow": "rgb(8,8,8)",
    "--color-scrollbar": "rgb(80,80,80)",
    "--filter-invert": "invert(1)",
    "--filter-brightness": "brightness(80%)",
    "--filter-brightness-more": "brightness(90%)",
};

export { THEME_LIGHT, THEME_DARK };